var _Dimensions$get;
import { Dimensions, PixelRatio } from 'react-native';
const BASE_SCREEN_WIDTH = 414; // 基准屏幕宽度，例如 iPhone 6/7/8 的宽度
const screenWidth = (_Dimensions$get = Dimensions.get('window')) === null || _Dimensions$get === void 0 ? void 0 : _Dimensions$get.width;
export function lrpx(num) {
  const elemWidth = typeof num === "number" ? num : parseFloat(num);
  const renderPixel = screenWidth / BASE_SCREEN_WIDTH * elemWidth;
  return PixelRatio.roundToNearestPixel(renderPixel);
}